module.exports = __webpack_public_path__ + "img/block_6.e6b92f6f.webp";